module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.19801/js/img/tabs/tab-background.svg"